import axios from "axios";
import { baseURL } from "../constants/const";
import { notificationBus } from "./notificationBus";
import i18n from "../i18next/i18n";

const instance = axios.create({
  baseURL: baseURL,
});
const instancePrintServer = axios.create({
  baseURL: "http://localhost:8085/",
});

instance.interceptors.request.use((config) => {
  const token = localStorage.getItem("accessToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    if (status === 401) {
      localStorage.removeItem("accessToken");
      window.location.replace("/login");
    } else if (status === 403) {
      notificationBus.notify(i18n.t("error.accessDenied", { ns: "global" }), "warning");
    } else if (status === 400) {
      notificationBus.notify(i18n.t("error.badRequest", { ns: "global" }), "warning");
    } else if (status >= 500) {
      notificationBus.notify(i18n.t("error.serverError", { ns: "global" }), "error");
    } else if (!error.response) {
      notificationBus.notify(i18n.t("error.noServerResponse", { ns: "global" }), "error");
    }
    return Promise.reject(error);
  }
);

export const blockTicket = async (params) => {
  const response = await instance.post("/block-ticket", params, {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
  return response;
};

export const getCountExits = async () => {
  const response = await instance.get("/count-exit");
  return response.data;
};

export const getAntiPassbackReset = async () => {
  const response = await instance.get("/anti-passback-reset");
  return response.data;
};

export const countExit = async (value) => {
  const response = await instance.post("/count-exit", value, {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
  return response;
};

export const antiPassbackResetSet = async (value) => {
  const response = await instance.post("/anti-passback-reset", value, {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
  return response;
};

export const getActiveTickets = async (startDate, endDate) => {
  const response = await instance.get("/active-tickets", {
    params: { startDate, endDate },
  });
  return response.data;
};

export const getNonActiveTickets = async (startDate, endDate) => {
  const response = await instance.get("/nonactive-tickets", {
    params: { startDate, endDate },
  });
  return response.data;
};
export const getExpiredTickets = async (startDate, endDate) => {
  const response = await instance.get("/expired-in-period", {
    params: { startDate, endDate },
  });
  return response.data;
};

export const getNonactiveAndExpiredTickets = async (startDate, endDate) => {
  const response = await instance.get("/nonactive-and-expired-tickets", {
    params: { startDate, endDate },
  });
  return response.data;
};

export const getMonitoring = async () => {
  const response = await instance.get("/monitoring");
  console.log(response);
  return response.data;
};

export const getRgroups = async () => {
  const response = await instance.get("/get-rgroups");
  const data = response.data;
  if (data?.success === true && Array.isArray(data?.data)) {
    return data.data;
  }
  if (data?.success === false) {
    throw new Error(data?.message);
  }
  return [];
};
export const getPassedTickets = async (startDate, endDate) => {
  const response = await instance.get("/passed", {
    params: { startDate, endDate },
  });
  return response.data;
};
export const getSuccPassedTickets = async (startDate, endDate) => {
  const response = await instance.get("/passed-succ", {
    params: { startDate, endDate },
  });
  return response.data;
};
export const getTopSuccPassedTickets = async (startDate, endDate) => {
  const response = await instance.get("/top-passed-succ", {
    params: { startDate, endDate },
  });
  return response.data;
};
export const getSoldTickets = async (startDate, endDate) => {
  const response = await instance.get("/sold-tickets", {
    params: { startDate, endDate },
  });
  return response.data;
};

// Broj korišćenja (uspešnih ulaza) po kartici u poslednjih N sati.
// hours mora biti jedna od dozvoljenih vrednosti (1,2,3,5,8,12) — validira i backend.
// serial je opcion; ako je prazan, izostavlja se iz zahteva.
export const getCardUsage = async (hours, serial) => {
  const params = { hours };
  if (serial) {
    params.serial = serial;
  }
  const response = await instance.get("/card-usage", { params });
  return response.data;
};

export const getTicketsBySubmitter = async (submitter, startDate, endDate) => {
  const response = await instance.get("/tickets-by-submitter", {
    params: { submitter, startDate, endDate },
  });
  return response.data;
};
export const getReportOptions = async (param) => {
  //console.log(param);
  const response = await instance.get("/report-options", {
    params: { param },
  });
  //console.log(response);
  return response.data;
};

export const getCanteenReport = async (startDate, endDate) => {
  const response = await instance.get(
    `/canteen/report?startDate=${startDate}&endDate=${endDate}`
  );
  console.log(response);
  return response.data;
};

export const getCategoryTickets = async (
  startDate,
  endDate,
  selectedOption
) => {
  const response = await instance.get("/sold-category", {
    params: { startDate, endDate, selectedOption },
  });
  return response.data;
};

export const getTypeTickets = async (startDate, endDate, selectedOption) => {
  const response = await instance.get("/sold-type", {
    params: { startDate, endDate, selectedOption },
  });
  return response.data;
};

export const getKindTickets = async (startDate, endDate, selectedOption) => {
  const response = await instance.get("/sold-kind", {
    params: { startDate, endDate, selectedOption },
  });
  return response.data;
};

export const getLogTickets = async (startDate, endDate, selectedOption) => {
  const response = await instance.get("/sold-log", {
    params: { startDate, endDate, selectedOption },
  });
  return response.data;
};

export const getPaymentMethodTickets = async (
  startDate,
  endDate,
  selectedOption
) => {
  const response = await instance.get("/payment-method", {
    params: { startDate, endDate, selectedOption },
  });
  return response.data;
};
export const getReaderIdExist = async (id) => {
  const response = await instance.get(`/reader/check-id`, {
    params: { id },
  });
  return response.data;
};
export const getReaders = async () => {
  //console.log("get readers");
  const response = await instance.get("/reader/get-readers");
  //console.log(response);
  return response.data;
};
export const getActiveReaders = async () => {
  //console.log("get readers");
  const response = await instance.get("/get-active-readers");
  //console.log(response);
  return response.data;
};

export const getDaysHIK = async () => {
  const response = await instance.get("/days-hik-images");
  return response.data;
};

export const postDaysHIK = async (value) => {
  const response = await instance.post("/days-hik-images", value, {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
  return response.data;
};

export const getWSLog = async (lines) => {
  const response = await instance.get("/get-ws-log", {
    params: { lines },
  });
  return response.data;
};

export const getFTPLog = async (lines) => {
  const response = await instance.get("/get-ftp-log", {
    params: { lines },
  });
  return response.data;
};

export const getAppLogsListing = async () => {
  const response = await instance.get("/get-app-logs");
  return response.data;
};

export const getAppLogFile = async (folder, file) => {
  const response = await instance.get("/get-app-logs", {
    params: { folder, file },
  });
  return response.data;
};

export const getMailSettings = async () => {
  const response = await instance.get("/mail-configs");
  //console.log(response);
  return response.data;
};
export const getReaderData = async (id) => {
  //console.log("get readers");
  const response = await instance.get("/reader/get-reader", {
    params: { id },
  });
  //console.log(response);
  return response.data;
};
export const getItemData = async (id) => {
  const response = await instance.post("/get-item", id, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
  console.log(response);
  return response.data[0];
};
export const getTicketIdExist = async (id) => {
  const response = await instance.get(`/ticket/check-id`, {
    params: { id },
  });
  return response.data;
};
export const getUserExist = async (username) => {
  const response = await instance.get(`/users/check`, {
    params: { username },
  });
  return response.data;
};
export const getDailyReport = async (startDate, endDate) => {
  const response = await instance.get("/daily-report", {
    params: { startDate, endDate },
  });
  return response.data;
};
export const getInfoPerTID = async (ticket_id) => {
  const response = await instance.get(`/ticket/info-id`, {
    params: { ticket_id },
  });
  console.log(response.data);
  return response.data;
};

export const getInfoPerRegistrationPlate = async (params) => {
  const response = await instance.post("/search-plates", params, {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
  //console.log("getInfoPerRegistrationPlate response:", response.data);
  return response.data.data;
};
export const getImages = async (reader, count, days, id = undefined) => {
  const params = {
    ...(id ? { id } : {}), // Add `id` only if it's defined and not empty
    reader,
    count,
  };
  //console.log(params);
  const response = await instance.get(`/get-pass-images`, { params: params });
  //console.log(response);
  return response.data;
};

export const getAndroidLogById = async (id) => {
  const response = await instance.get(`/android-log?deviceId=${id}`);
  //console.log(response.data);
  return response.data;
};

export const getAllAndroidLogs = async () => {
  const response = await instance.get("/android-log?all");
  //console.log(response.data);
  return response.data;
};
export const getImage = async (id, reader) => {
  const params = {
    id,
    reader,
  };

  const response = await instance.get(`/get-pass-image`, { params: params });
  return response.data;
};
export const getUsersExceptLogin = async (username) => {
  const response = await instance.get(`/perm/users`, {
    params: { username },
  });
  return response.data;
};
export const getPages = async () => {
  const response = await instance.get(`/perm/pages`);
  return response.data;
};
export const getPermisisons = async (user_id) => {
  const response = await instance.get(`/perm/permissions`, {
    params: { user_id },
  });
  return response.data;
};
export const getTicket = async (id) => {
  const response = await instance.get(`/get/ticket`, {
    params: { id },
  });
  //console.log("getTicket response:", response.data);
  return response.data;
};
export const getPriceList = async () => {
  const response = await instance.get("/price-list");
  return response.data.price_list;
};

const makeRequest = async (method, endpoint, data, contentType) => {
  const ret = { success: false, message: "", other: "" };
  try {
    const response = await instance[method](endpoint, data, {
      headers: { "Content-Type": contentType },
    });
    ret.success = response.data.success;
    ret.message = response.data.message || "Request successful";
    ret.other = response.data.other;
    return ret;
  } catch (error) {
    if (!error.response) {
      ret.message = "No server response";
    } else if (error.response.status === 400) {
      ret.message = "Bad Request";
    } else if (error.response.status === 401) {
      ret.message = "Unauthorized";
    } else {
      ret.message = "Request failed";
    }
    return ret;
  }
};

export const postRequest = (endpoint, formData) =>
  makeRequest("post", endpoint, formData, "application/x-www-form-urlencoded");

export const postRequestJson = (endpoint, data) =>
  makeRequest("post", endpoint, data, "application/json");

export const putRequest = (endpoint, formData) =>
  makeRequest("put", endpoint, formData, "application/x-www-form-urlencoded");

export const updatePassword = async (userData) => {
  let ret = { success: false, message: "" };
  try {
    const response = await instance.put(
      `/users/update-password`,
      JSON.stringify({
        username: userData.username,
        newPassword: userData.newPassword,
      }),
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    ret.success = response.data.success;
    ret.message = response.data.message || "Password updated successfully";
    return ret;
  } catch (error) {
    console.error("Error updating password:", error);
    if (error.response) {
      ret.success = false;
      ret.message = error.response.data?.message || "Failed to update password";
    } else {
      ret.message = "Network error or server unavailable";
    }
    return ret;
  }
};

export const editReader = async (reader) => {
  let ret = { success: false, message: "" };
  try {
    const response = await instance.put(`/edit/reader`, reader, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    ret.success = response.data.success;
    ret.message = response.data.message || "Request successful";
    return ret;
  } catch (error) {
    console.error("Error put data:", error);
    if (!error.response) {
      console.log("No server response");
      ret.message = "No server response";
    }
    return ret;
  }
};
export const editTicket = async (ticket) => {
  let ret = { success: false, message: "" };
  try {
    const response = await instance.put(`/edit/ticket`, ticket, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    ret.success = response.data.success;
    ret.message = response.data.message || "Request successful";
    return ret;
  } catch (error) {
    console.error("Error put data:", error);
    if (!error.response) {
      console.log("No server response");
      ret.message = "No server response";
    }
    return ret;
  }
};
export const editTicketUser = async (user) => {
  let ret = { success: false, message: "" };
  try {
    const response = await instance.put(`/edit/ticket-user`, user, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    ret.success = response.data.success;
    ret.message = response.data.message || "Request successful";
    return ret;
  } catch (error) {
    console.error("Error put data:", error);
    if (!error.response) {
      console.log("No server response");
      ret.message = "No server response";
    }
    return ret;
  }
};

export const getTypes = async () => {
  const response = await instance.get("/get-types");
  return response.data;
};

export const getUpdateFiles = async () => {
  const response = await instance.get("/get-versions");
  return response.data;
};

export const getKinds = async () => {
  const response = await instance.get("/get-kinds");
  return response.data;
};

export const getCategories = async () => {
  const response = await instance.get("/get-categories");
  return response.data;
};

export const getOrganizationUnitById = async (id) => {
  const response = await instance.get(`/canteen/organization-unit?${id}`);
  return response.data;
};

export const getOrgranizationalUnits = async () => {
  const response = await instance.get("/canteen/organization-unit?all");
  return response.data;
};

export const addArticle = async (params) => {
  const response = await instance.post(
    "/canteen/article",
    JSON.stringify(params),
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};

export const addIngredient = async (params) => {
  const response = await instance.post(
    "/canteen/ingredient",
    JSON.stringify(params),
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};

export const addEmployee = async (params) => {
  const response = await instance.post(
    "/canteen/employee",
    JSON.stringify(params),
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};
export const addRecipe = async (params) => {
  const response = await instance.post(
    "/canteen/recipe",
    JSON.stringify(params),
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};

export const addUnitOfMeasure = async (params) => {
  const response = await instance.post(
    "/canteen/unit-of-measure-unit",
    JSON.stringify(params),
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};

export const addOrganizationUnit = async (params) => {
  const response = await instance.post(
    "/canteen/organization-unit",
    JSON.stringify(params),
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};

export const editArticle = async (params) => {
  const response = await instance.put(
    "/canteen/article",
    JSON.stringify(params),
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};

export const editIngredient = async (params) => {
  const response = await instance.put(
    "/canteen/ingredient",
    JSON.stringify(params),
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};

export const editRecipe = async (params) => {
  const response = await instance.put(
    "/canteen/recipe",
    JSON.stringify(params),
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};

export const editEmployee = async (params) => {
  const response = await instance.put(
    "/canteen/employee",
    JSON.stringify(params),
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};

export const editUnitOfMeasure = async (params) => {
  const response = await instance.put(
    "/canteen/unit-of-measure-unit",
    JSON.stringify(params),
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};

export const editOrganizationUnit = async (params) => {
  const response = await instance.put(
    "/canteen/organization-unit",
    JSON.stringify(params),
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};

export const getArticles = async () => {
  const response = await instance.get("/canteen/article?all");
  return response.data;
};
export const getRecipes = async () => {
  const response = await instance.get("/canteen/recipe?all");
  return response.data;
};
export const getIngredients = async () => {
  const response = await instance.get("/canteen/ingredient?all");
  return response.data;
};

export const getEmployees = async () => {
  const response = await instance.get("/canteen/employee?all");
  return response.data;
};

export const getUnitsOfMeasure = async () => {
  const response = await instance.get("/canteen/unit-of-measure-unit?all");
  return response.data;
};

export const addItem = async (params) => {
  const response = await instance.post("/add-item", params, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
  return response;
};

export const ticketSendEmail = async (formData) => {
  const response = await instance.post("/send-mail", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response;
};

export const changeUserPassword = async (params) => {
  const response = await instance.post("/change-password", params, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
  return response.data;
};

export const addKind = async (params) => {
  const response = await instance.post("/add-kind", params, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
  return response.data;
};

export const addType = async (params) => {
  const response = await instance.post("/add-type", params, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
  return response.data;
};

export const addCategory = async (params) => {
  const response = await instance.post("/add-category", params, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
  return response.data;
};

export const searchUsersWithTickets = async (params) => {
  const response = await instance.post("/search-users", params, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
  return response.data;
};

export const deleteEmployee = async (id) => {
  const response = await instance.delete(`/canteen/employee?id=${id}`);
  return response.data;
};

export const deleteOrganizationUnit = async (id) => {
  const response = await instance.delete(
    `/canteen/organization-unit?id=${id}`
  );
  return response.data;
};

export const deleteUnitOfMeasure = async (id) => {
  const response = await instance.delete(
    `/canteen/unit-of-measure-unit?id=${id}`
  );
  return response.data;
};

export const deleteArticle = async (id) => {
  const response = await instance.delete(`/canteen/article?id=${id}`);
  return response.data;
};

export const deleteIngredient = async (id) => {
  const response = await instance.delete(`/canteen/ingredient?id=${id}`);
  return response.data;
};

export const deleteItem = async (params) => {
  const response = await instance.post("/delete-item", params, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
  return response.data;
};

export const deleteKind = async (params) => {
  const response = await instance.post("/delete-kind", params, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });

  return response.data;
};

export const editCategory = async (params) => {
  const response = await instance.post("/edit-category", params, {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
  return response.data;
};

export const editKind = async (params) => {
  const response = await instance.post("/edit-kind", params, {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
  return response.data;
};

export const editType = async (params) => {
  const response = await instance.post("/edit-type", params, {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
  return response.data;
};

export const deleteType = async (params) => {
  const response = await instance.post("/delete-type", params, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
  return response.data;
};

export const deleteCategory = async (params) => {
  const response = await instance.post("/delete-category", params, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
  return response.data;
};

export const deleteReader = async (params) => {
  const response = await instance.post("/delete-reader", params, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
  return response.data;
};

export const updateDatabase = async () => {
  const response = await instance.post("/update-database", null, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
  return response.data;
};

// PRINT SERVER - PORT 8085

export const openPrinterSession = async () => {
  const response = await instance.post(
    "/printer/open",
    {},
    {
      baseURL: "http://localhost:8085/",
      headers: {
        "X-API-KEY": "123456",
      },
    }
  );
  return response.data;
};

export const sendTicketData = async (ticketData, paymentType, mode) => {
  const payload = { ...ticketData, paymentType, mode };

  const response = await instancePrintServer.post("/printer/data", payload, {
    baseURL: "http://localhost:8085/",
    headers: {
      "X-API-KEY": "123456",
      "Content-Type": "application/json",
    },
  });
  return response.data;
};

export const closePrinterSession = async () => {
  const response = await instance.post(
    "/printer/close",
    {},
    {
      baseURL: "http://localhost:8085/",
      headers: { "X-API-KEY": "123456" },
    }
  );
  console.log(response);
  return response.data;
};
// dizajn karte

export const getDesigns = async () => {
  const response = await instance.get("/ticket-design");
  return response.data;
};
export const deleteDesign = async (id) => {
  const response = await instance.delete("/ticket-design", {
    params: { id },
  });
  return response;
};
export const saveTicketDesign = async (designData) => {
  const response = await instance.post("/ticket-design", designData, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
  return response.data;
};

export const sendTicketConfig = async (designData) => {
  const response = await instance.post("printer/receive-design", designData, {
    baseURL: "http://localhost:8085/",
    headers: {
      "X-API-KEY": "123456",
      "Content-Type": "application/json",
    },
  });
  return response.data;
};

export const getTicketConfig = async () => {
  try {
    const response = await instance.get("printer/get-design", {
      baseURL: "http://localhost:8085/",
      headers: {
        "X-API-KEY": "123456",
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Greška pri preuzimanju konfiguracije karte:", error);
    return null; // Ako dođe do greške, vrati null umesto undefined
  }
};
// fiskalizacija
export const fiskalizacija = async (
  ticketData,
  paymentType,
  mode,
  isAdvance
) => {
  const payload = { ticketData, paymentType, mode, isAdvance };

  const response = await instance.post("printer/fiskalizuj", payload, {
    baseURL: "http://localhost:8085/",
    headers: {
      "X-API-KEY": "123456",
      "Content-Type": "application/json",
    },
  });
  if (response.status === 200) {
    await closePrinterSession(); // Zatvori sesiju za štampanje
  } else {
    console.error("Fiskalizacija nije uspela sa statusom:", response.status);
  }
  let fiskRes = response.data;

  // Ako je string u obliku {key=value, key2=value2,...}, parsiramo ga u objekt
  if (typeof fiskRes === "string") {
    const parsed = {};
    fiskRes
      .replace(/[{}]/g, "") // ukloni {}
      .split(", ")
      .forEach((pair) => {
        const [key, value] = pair.split("=");
        parsed[key.trim()] = value.trim();
      });
    fiskRes = parsed;
  }

  return fiskRes;
};

// 1️⃣ STARTNI AVANSNI RAČUN
// Modifikovana createAdvanceStart funkcija
export const createAdvanceStart = async ({
  ticketData,
  payment,
  advanceAmount,
}) => {
  const payload = {
    ticketData,
    payment,
    advanceAmount,
  };

  const response = await instance.post("/printer/advance/start", payload, {
    baseURL: "http://localhost:8085/",
    headers: {
      "X-API-KEY": "123456",
      "Content-Type": "application/json",
    },
  });

  if (response.status === 200) {
    await closePrinterSession(); // Zatvori sesiju za štampanje
  } else {
    console.error("Fiskalizacija nije uspela sa statusom:", response.status);
  }
  if (response.status === 200 || response.status === 201) {
    console.log("✅ Startni avansni račun uspešno kreiran", response.data);
    return response.data;
  } else {
    console.error(
      "❌ Greška pri kreiranju startnog avansnog računa:",
      response.status
    );
    return null;
  }
};

// 2️⃣ NAREDNI AVANSNI RAČUN
export const createAdvanceNext = async (payload) => {
  const response = await instance.post("printer/advance/next", payload, {
    baseURL: "http://localhost:8085/",
    headers: {
      "X-API-KEY": "123456",
      "Content-Type": "application/json",
    },
  });

  if (response.status === 200 || response.status === 201) {
    console.log("✅ Naredni avansni račun uspešno kreiran");
  } else {
    console.error(
      "❌ Greška pri kreiranju narednog avansnog računa:",
      response.status
    );
  }

  if (response.status === 200) {
    await closePrinterSession(); // Zatvori sesiju za štampanje
  } else {
    console.error("Fiskalizacija nije uspela sa statusom:", response.status);
  }
  return response.data;
};

// 3️⃣ FINALNI AVANSNI RAČUN
export const createAdvanceFinal = async (finalData) => {
  const response = await instance.post("printer/advance/final", finalData, {
    baseURL: "http://localhost:8085/",
    headers: {
      "X-API-KEY": "123456",
      "Content-Type": "application/json",
    },
  });

  if (response.status === 200 || response.status === 201) {
    console.log("✅ Finalni avansni račun uspešno kreiran");
  } else {
    console.error(
      "❌ Greška pri kreiranju finalnog avansnog računa:",
      response.status
    );
  }

  if (response.status === 200) {
    await closePrinterSession(); // Zatvori sesiju za štampanje
  } else {
    console.error("Fiskalizacija nije uspela sa statusom:", response.status);
  }
  return response.data;
};

// reports
export const sendReportsData = async (reportsData) => {
  const response = await axios.post(
    "http://localhost:8085/printer/reports",
    reportsData,
    {
      headers: {
        "X-API-KEY": "123456",
        "Content-Type": "application/json",
      },
    }
  );
  console.log(response);
  return response.data;
};

export const getInvoices = async () => {
  try {
    const response = await instance.get("printer/get-refund", {
      baseURL: "http://localhost:8085/",
      headers: {
        "X-API-KEY": "123456",
        "Content-Type": "application/json",
      },
    });

    const lines = response.data.trim().split("\n");
    const invoiceNumbers = lines.map((line) => line.split(",")[0]); // uzimamo samo broj računa

    return invoiceNumbers;
  } catch (error) {
    console.error("Greška pri preuzimanju racuna:", error);
    return []; // Ako dođe do greške, vrati null umesto undefined
  }
};
// END (PRINT SERVER)

export const openBarrier = async (params) => {
  const response = await instance.post("/open-barrier", params, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
  return response.data;
};

export const soundSupport = async ({
  command,
  serial_number,
  target_device_id,
  payload,
}) => {
  const formData = new URLSearchParams();
  formData.append("command", command);
  formData.append("serial_number", serial_number);
  if (target_device_id) formData.append("target_device_id", target_device_id);
  if (payload) formData.append("payload", JSON.stringify(payload));

  const response = await instance.post("/sound-support", formData, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
  return response.data;
};

export const getTemplateGroups = async () => {
  const response = await instance.get("/get-groups", {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
  return response.data;
};

export const addTemplateGroup = async (params) => {
  const response = await instance.post("/add-group", params, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
  return response.data;
};

export const getTemplateGroupEvents = async () => {
  const response = await instance.get("/get-group-events", {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
  return response.data;
};

export const addTemplateGroupEvent = async (params) => {
  const response = await instance.post("/add-group-event", params, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
  return response.data;
};

export const getTicketTemplates = async () => {
  const response = await instance.get("/ticket-templates", {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
  return response.data;
};

export const getTicketTemplateById = async (id) => {
  const response = await instance.get(`/ticket-templates?id=${id}`, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
  return response.data;
};

export const addTicketTemplate = async (params) => {
  const response = await instance.post("/ticket-templates", params, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
  return response.data;
};

export const updateTicketTemplate = async (id, params) => {
  const formData = new URLSearchParams();
  formData.append("id", id);
  Object.keys(params).forEach((key) => {
    const val = params[key];
    if (Array.isArray(val)) {
      if (val.length === 0) {
        formData.append(`${key}[]`, ''); // prazan niz → signal BE-u da obriše sve
      } else {
        val.forEach(v => formData.append(`${key}[]`, v));
      }
    } else {
      formData.append(key, val);
    }
  });
  const response = await instance.put("/ticket-templates", formData, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
  return response.data;
};

export const deleteTicketTemplate = async (id) => {
  const response = await instance.delete(`/ticket-templates?id=${id}`);
  return response.data;
};

export const getPeriods = async () => {
  const response = await instance.get("/period?all=1", {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response.data;
};

export const getPeriodById = async (id) => {
  const response = await instance.get(`/period?id=${id}`, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response.data;
};

export const addPeriod = async (params) => {
  const response = await instance.post("/period", params, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response.data;
};

export const updatePeriod = async (id, params) => {
  const response = await instance.put(
    "/period",
    { id, ...params },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};

export const deletePeriod = async (id) => {
  const response = await instance.delete(`/period?id=${id}`);
  return response.data;
};

export const getGroupById = async (id) => {
  const response = await instance.get(`/get-group-by-id?id=${id}`, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
  return response.data;
};

export const getMode = async () => {
  const response = await instance.get(`/get-mode`, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
  return response.data;
};

export const getFiscalizationMode = async () => {
  const response = await instance.get(`/fiscalization-mode`, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
  return response.data;
};

export const getFiscalizationStatus = async () => {
  const response = await instance.get(`/fiscalization-mode`, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
  return response.data;
};

export const getLockers = async () => {
  const response = await instance.get(`/lockers/locker?all`, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
  return response.data;
};

export const addLockerGroup = async (params) => {
  const response = await instance.post(
    "/lockers/locker",
    JSON.stringify(params),
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response;
};

export const updateLocker = async (params) => {
  const response = await instance.put(
    "/lockers/locker",
    JSON.stringify(params),
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response;
};

export const deleteLocker = async (id) => {
  const response = await instance.delete(`/lockers/locker?id=${id}`, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response;
};

export const listBackups = async () => {
  const params = new URLSearchParams();
  params.append("action", "list-backups");

  const response = await instance.post(`/database-backup`, params, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
  return response.data;
};

export const createBackup = async () => {
  const params = new URLSearchParams();
  params.append("action", "create-backup");

  const response = await instance.post(`/database-backup`, params, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
  return response.data;
};
export const runBackup = async (filename) => {
  const params = new URLSearchParams();
  params.append("action", "run-backup");
  params.append("filename", filename);

  const response = await instance.post(`/database-backup`, params, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
  return response.data;
};
export const latestBackup = async () => {
  const params = new URLSearchParams();
  params.append("action", "get-latest-backup");

  const response = await instance.post(`/database-backup`, params, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
  return response.data;
};
export const getCameraMode = async () => {
  const response = await instance.get(`/get-camera-mode`, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
  return response.data;
};

export const runUpdate = async (filename) => {
  const params = new URLSearchParams();
  params.append("action", "run-update");
  params.append("version", filename);

  const response = await instance.post(`/database-backup`, params, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
  return response.data;
};
export const getUpdate = async (filename) => {
  const params = new URLSearchParams();
  params.append("action", "get-update");
  params.append("filename", filename);

  const response = await instance.post(`/database-backup`, params, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
  return response.data;
};

export const sellTickets = async (cart, selectedPayments) => {
  // Priprema articles niza u formatu koji API očekuje
  const articles = cart.map((item) => ({
    article_id: item.id,
    count: item.quantity,
    ticket_ids: Array.from({ length: item.quantity }, () =>
      Math.floor(Math.random() * 1_000_000_000).toString()
    ),
  }));

  // Ako postoji neki payment info, uzimamo prvi za registration/template_id (ili hardcod)
  const firstPaymentMethod = selectedPayments[0]?.method || "Cash";

  const payload = {
    phone: "0601234567", // ili zameni dinamički
    name: "test",
    surname: "test",
    articles: articles,
    registration: firstPaymentMethod, // možeš staviti nešto smisleno, npr. reg. broj ili payment method
    template_id: "unknown",
  };

  console.log("📦 Sending payload to sellTickets:", payload);

  const response = await instance.post("/sell-tickets", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYXRlIjoiMTAwNzIwMjQiLCJuYW1lIjoiQnVzIExvZ2ljIiwiYXV0aG9yIjoxOTA0MDAwfQ.wwTrELk7qktXS8dT65cysTlYlTtMIMQUAaIMv1Tc32w`,
    },
  });

  return response.data;
};

export const getCompanies = async () => {
  const response = await instance.get(`/company?all`, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
  return response.data;
};

export const addCompany = async (params) => {
  const response = await instance.post("/company", JSON.stringify(params), {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response;
};

export const updateCompany = async (params) => {
  const response = await instance.put("/company", JSON.stringify(params), {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response;
};

export const deleteCompany = async (id) => {
  const response = await instance.delete(`/company?id=${id}`, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response;
};

export const getAdvanceInvoices = async () => {
  const response = await instance.get(`/advance?all`, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
  return response.data;
};

export const addAdvanceInvoice = async (params) => {
  const response = await instance.post("/advance", JSON.stringify(params), {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response;
};

export const updateAdvanceInvoice = async (params) => {
  const response = await instance.put("/advance", JSON.stringify(params), {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response;
};

export const deleteAdvanceInvoice = async (id) => {
  const response = await instance.delete(`/advance?id=${id}`, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response;
};

export const getAdvanceInvoicesByPIB = async (pib) => {
  const response = await instance.get(`/advance?PIB=${pib}`, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response.data;
};

export const advanceValidation = async (params) => {
  const response = await instance.post(
    `/advance-validation`,
    JSON.stringify(params),
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};

// Camera/Hik API functions
export const getCameraStatistics = async () => {
  const response = await instance.get("/camera-api?action=statistics");
  // Backend returns {success: true, data: {...}}, extract data
  if (response.data && response.data.success && response.data.data) {
    const stats = response.data.data;
    // Map backend fields to frontend expected fields
    // Backend tracks all PLATES events (ANPR), with success/failure via reject field
    // Total events = all ANPR events, heartbeat events are not tracked separately
    return {
      total_events: parseInt(stats.total_events) || 0,
      anpr_events: parseInt(stats.total_events) || 0, // All events are ANPR
      heartbeat_events: 0, // Not tracked in current backend
      unique_plates: parseInt(stats.unique_plates) || 0,
      last_event: stats.last_event || null,
      // Also include backend-specific fields for reference
      successful_events: parseInt(stats.successful_events) || 0,
      failed_events: parseInt(stats.failed_events) || 0,
    };
  }
  return response.data;
};

export const getRecentEvents = async (limit = 50) => {
  const response = await instance.get(
    "/camera-api?action=recent_events&limit=" + limit
  );
  // Backend returns {success: true, data: [...], count: ...}, extract data array
  if (
    response.data &&
    response.data.success &&
    Array.isArray(response.data.data)
  ) {
    return response.data.data;
  }
  // Fallback: if data is already an array, return it
  if (Array.isArray(response.data)) {
    return response.data;
  }
  return [];
};

export const getCameraEvent = async (id) => {
  const response = await instance.get("/camera-api?action=event&id=" + id);
  // Backend returns {success: true, data: {...}}, extract data
  if (response.data && response.data.success && response.data.data) {
    return response.data.data;
  }
  // Fallback for error responses
  if (response.data && response.data.success === false) {
    throw new Error(response.data.error || "Event not found");
  }
  return response.data;
};

export const validatePlate = async (plate) => {
  const response = await instance.get(
    "/camera-api?action=validate_plate&plate=" + plate
  );
  // Backend returns {success: true, valid: ..., plate: ...}, extract data
  if (response.data && response.data.success !== undefined) {
    return {
      valid: response.data.valid || false,
      plate: response.data.plate || plate,
    };
  }
  return response.data;
};

export const getParkingLots = async () => {
  const response = await instance.get("/parking-lots");
  return response.data;
};

export const addParkingLot = async (params) => {
  const response = await instance.post("/parking-lots/add", params, {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
  return response.data;
};

export const editParkingLot = async (params) => {
  const response = await instance.post("/parking-lots/edit", params, {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
  return response.data;
};

export const deleteParkingLot = async (params) => {
  const response = await instance.post("/parking-lots/delete", params, {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
  return response.data;
};

export const getActiveTicketsByParking = async () => {
  const response = await instance.get("/active-tickets-by-parking");
  return response.data;
};

export const getSSEStreamURL = () => {
  return baseURL + "/camera-events?mode=stream";
};

export default instance;
